export const Sex = {
	MEN: { key: 0, name: '男' },
	WOMEN: { key: 1, name: '女' },
} as const;
export type SexType = typeof Sex[keyof typeof Sex];

export const findSexTypeNameByKey = (key: number) => {
	const sex = Object.values(Sex).find((p) => p.key === key);
	return sex ? sex.name : '';
};
